module.exports = __webpack_public_path__ + "img/pin-omni-core.5261188f.png";